<template>
  <v-container class="pt-0">
    <v-row
      ><v-col class="mx-0 px-0 pt-0">
        <v-card
          flat
          class="bar-header"
          :style="{
            background: setBackgoundBox(),
            borderRadius: setBorderRadiusBox(),
          }"
        >
          <v-container>
            <v-btn
              v-if="!inBottomNavbar"
              icon
              color="white"
              style="
                margin-top: 14px;
                margin-left: 2px;
                z-index: 2;
                position: absolute;
              "
              elevation="2"
              @click="redirectTo"
            >
              <v-icon large>mdi-chevron-left-circle</v-icon>
            </v-btn>

            <v-btn
              fab
              x-small
              color="white"
              :to="{ name: 'favorite-item' }"
              style="
                right: 16px;
                margin-top: 14px;
                z-index: 2;
                position: absolute;
              "
            >
              <v-icon small :color="site.color"> mdi-cards-heart </v-icon>
            </v-btn>

            <v-card-text class="text-center mt-n5">
              <span
                v-if="
                  !customHeader.isUseCustomHeader ||
                  (customHeader.isUseCustomHeader && customHeader.isUseTitle)
                "
                class="text-h6 text-center"
                style="
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  transform: translate(-50%, -50%);
                  font-weight: 600;
                "
                :style="{
                  color: this.customHeader.titleColor,
                  'text-shadow': checkTitleShadow(),
                }"
                >{{ $t("rewardPrize") }}
              </span>
            </v-card-text>
          </v-container>
        </v-card>
      </v-col>
    </v-row>

    <v-row justify="center" style="margin-top: -55px">
      <v-col cols="12" md="6" class="d-flex justify-center">
        <v-card
          elevation="2"
          color="white"
          dark
          :to="{ name: 'my-history' }"
          class="mx-2 d-flex align-center"
          style="height: 63px"
        >
          <v-card-text class="black--text py-1">
            <v-row class="my-3 mx-1 align-center">
              <div
                v-if="
                  Array.isArray(getCustomer.point) &&
                  getCustomer.point.length > 0
                "
                class="d-flex align-center justify-center"
                style="gap: 4px; max-width: 200px"
              >
                <PointSymbol
                  :type="getCustomer.point[0].point_type_type"
                  :symbol="getCustomer.point[0].point_type_symbol"
                  :color="getCustomer.point[0].point_type_color"
                  :is_display="true"
                  :outlined_box="false"
                  :size="24"
                />
                <div class="text-truncate" style="width: 100%">
                  {{ getCustomer.point[0].point | commaPoint }}
                  {{ getCustomer.point[0].point_type_name }}
                </div>
              </div>
            </v-row>
          </v-card-text>
        </v-card>
        <v-card
          elevation="2"
          color="white"
          dark
          :to="{ name: 'my-coupons' }"
          style="height: 63px"
        >
          <v-card-text class="black--text">
            <v-row class="ma-0">
              <div class="mt-auto mr-1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24.727"
                  height="17"
                  viewBox="0 0 24.727 17"
                >
                  <g id="coupon" transform="translate(0 -80)">
                    <g
                      id="Group_1025"
                      data-name="Group 1025"
                      transform="translate(0 80)"
                    >
                      <g
                        id="Group_1024"
                        data-name="Group 1024"
                        transform="translate(0 0)"
                      >
                        <path
                          id="Path_1645"
                          data-name="Path 1645"
                          d="M23.182,80H8.5a.778.778,0,0,0-.547.226l-1,1-1-1A.778.778,0,0,0,5.409,80H1.545A1.548,1.548,0,0,0,0,81.545V95.455A1.547,1.547,0,0,0,1.545,97H5.409a.778.778,0,0,0,.547-.226l1-1,1,1A.773.773,0,0,0,8.5,97H23.182a1.546,1.546,0,0,0,1.545-1.545V81.545A1.547,1.547,0,0,0,23.182,80ZM7.727,93.909H6.182V92.364H7.727Zm0-3.091H6.182V89.273H7.727Zm0-3.091H6.182V86.182H7.727Zm0-3.091H6.182V83.091H7.727Zm5.409-1.545a2.318,2.318,0,1,1-2.318,2.318A2.321,2.321,0,0,1,13.136,83.091ZM11.591,93.909A.773.773,0,0,1,11,92.642l7.727-9.273a.772.772,0,1,1,1.185.991l-7.727,9.273A.772.772,0,0,1,11.591,93.909Zm6.182,0a2.318,2.318,0,1,1,2.318-2.318A2.321,2.321,0,0,1,17.773,93.909Z"
                          transform="translate(0 -80)"
                          :fill="site.color"
                        />
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
              <p class="ma-1">
                {{ $t("couponPage") }}
              </p>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Partner Reward -->
    <v-row v-if="partnerList.length > 0" justify="center">
      <v-col cols="12" class="py-0">
        <v-slide-group class="py-0" center-active mandatory>
          <v-slide-item
            v-for="(item, index) in partnerList"
            :key="index"
            v-slot="{ toggle }"
            @change="handleOpenPartner(item)"
            style="width: 100%; min-width: 160px"
          >
            <v-card
              rounded="lg"
              class="px-2 ma-1"
              @click="toggle"
              elevation="1"
            >
              <v-container class="pa-0 d-flex justify-center align-center">
                <img
                  v-if="item.image"
                  :src="item.image"
                  class="ma-0"
                  style="height: 64px; object-fit: contain"
                />
                <p v-else class="ma-0 pa-4">{{ item.name }}</p>
              </v-container>
            </v-card>
          </v-slide-item>
        </v-slide-group>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12" sm="10" md="8">
        <v-slide-group class="py-0" center-active mandatory show-arrows>
          <!-- Slot ปุ่มกดฝั่งซ้าย (Prev) -->
          <template v-slot:prev="{ on, attrs }">
            <v-btn
              icon
              fab
              x-small
              v-bind="attrs"
              v-on="on"
              class="custom-slide-btn"
            >
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
          </template>

          <!-- Slot ปุ่มกดฝั่งขวา (Next) -->
          <template v-slot:next="{ on, attrs }">
            <v-btn
              icon
              fab
              x-small
              v-bind="attrs"
              v-on="on"
              class="custom-slide-btn"
            >
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </template>

          <v-slide-item
            v-for="cate in categoryList"
            :key="cate.id"
            v-slot="{ active, toggle }"
            @change="initialize(cate)"
          >
            <v-card
              rounded="lg"
              class="px-2 mx-1"
              @click="toggle"
              elevation="0"
              width="15%"
              :style="
                active
                  ? { border: '1.5px solid', 'border-color': site.color }
                  : ''
              "
            >
              <v-container class="pa-0">
                <v-col class="d-flex justify-center pt-2 pb-0">
                  <v-icon :color="site.color">{{ `mdi-${cate.icon}` }}</v-icon>
                </v-col>
                <p style="font-size: 12px" class="text-center mb-0">
                  {{ cate.label }}
                </p>
              </v-container>
            </v-card>
          </v-slide-item>
        </v-slide-group>
      </v-col>
    </v-row>

    <v-container class="pt-0 mt-2">
      <v-row class="mt-1">
        <v-col
          v-for="(item, index) in dataItems"
          :key="index"
          class="px-2 py-2"
          cols="6"
          sm="4"
          lg="2"
          md="3"
        >
          <div>
            <v-card
              class="rounded-lg pa-3 card-container"
              :class="{ 'disabled-card': item.limit_reached }"
              outlined
              elevation="1"
              width="100%"
              style="border: none"
              :disabled="checkExpire(item.expires_at, item.limit_reached)"
              @click="confirmRedeem(item)"
            >
              <div
                v-if="item.limit_reached"
                class="d-flex justify-center align-center text-center cover-card-disable"
              >
                <div class="label">{{ $t("rewardLimitReached") }}</div>
              </div>
              <div
                v-else-if="item.status == 'coming soon'"
                class="d-flex justify-center align-center text-center cover-card-disable"
              >
                <div class="label">{{ $t("rewardComingSoon") }}</div>
              </div>

              <v-img
                :cover="true"
                :aspect-ratio="1"
                width="100%"
                :lazy-src="require('@/assets/images/image.png')"
                :src="item.image_url"
              >
              </v-img>

              <p
                class="title-mission text-start mb-auto text-subtitle-2 black--text"
                v-snip="{ lines: 2 }"
              >
                {{ item.name }}
              </p>

              <v-row
                v-if="!checkExpire(item.expires_at)"
                class="bottomleft mb-0 text-start text-subtitle-2 d-flex align-center"
                style="width: 100%"
              >
                <div class="ma-1">
                  <PointSymbol
                    v-if="
                      Array.isArray(item.point_used) &&
                      item.point_used.length > 0
                    "
                    :type="item.point_used[0].point_type_type"
                    :symbol="item.point_used[0].point_type_symbol"
                    :color="item.point_used[0].point_type_color"
                    :is_display="true"
                    :outlined_box="false"
                    :size="20"
                  />
                </div>
                <p
                  v-if="
                    Array.isArray(item.point_used) && item.point_used.length > 0
                  "
                  class="pa-0 my-1 pl-0 text-truncate"
                  style="width: calc(100% - 48px)"
                  :style="{ color: site.color }"
                >
                  {{ item.point_used[0].point | commaPoint }}
                  {{ item.point_used[0].point_type_name }}
                </p>
              </v-row>

              <v-row class="bottomleft mb-0 text-start text-subtitle-2" v-else>
                <v-img
                  :src="require('@/assets/images/expired.png')"
                  max-height="20"
                  max-width="20"
                  class="ma-1 d-block"
                ></v-img>
                <p class="pa-0 my-1 pl-0 text-truncate">
                  {{ $t("expireTime") }}
                </p>
              </v-row>
            </v-card>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <div v-if="!dataItems.length">
      <v-col class="d-flex justify-center mt-16">
        <v-img
          class="white--text mx-auto mt-10 empty"
          :src="require('@/assets/images/out-of-stock.png')"
          max-width="150px"
        >
        </v-img>
      </v-col>
      <p class="text-center">{{ $t("errDataNotFound") }}</p>
    </div>

    <div>
      <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler">
        <div slot="spinner"></div>
        <div slot="no-more"></div>
        <div slot="no-results"></div>
      </infinite-loading>
    </div>

    <v-dialog v-model="dialogAddFavorite" persistent max-width="290">
      <v-card>
        <v-card-text class="text-h6 text-center mt-0 pa-4">
          {{ $t("confirmAdd") }} <br />
          <span :style="{ color: site.color }" class="font-weight-bold">{{
            item.name
          }}</span
          ><br />
          {{ $t("inYourFav") }} ?
        </v-card-text>
        <v-card-actions class="pb-5">
          <v-spacer></v-spacer>
          <v-btn
            :color="site.color"
            class="rounded-lg white--text"
            depressed
            @click="addFavorite()"
          >
            {{ $t("confirm") }}
          </v-btn>
          <v-btn
            :color="site.color"
            class="rounded-lg"
            outlined
            @click="dialogAddFavorite = false"
          >
            {{ $t("cancel") }}
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogDeleteFavorite" persistent max-width="290">
      <v-card>
        <v-card-text class="text-h6 text-center mt-0 pa-4" :color="site.color">
          {{ $t("confirmDelete") }} <br />
          <span :style="{ color: site.color }" class="font-weight-bold">{{
            item.name
          }}</span
          ><br />
          {{ $t("fromYourFav") }} ?
        </v-card-text>

        <v-card-actions class="pb-5">
          <v-spacer></v-spacer>
          <v-btn
            :color="site.color"
            class="rounded-lg white--text"
            depressed
            @click="deleteFavorite()"
          >
            {{ $t("confirm") }}
          </v-btn>
          <v-btn
            :color="site.color"
            class="rounded-lg"
            outlined
            @click="dialogDeleteFavorite = false"
          >
            {{ $t("cancel") }}
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div
      class="fab-container"
      :style="{
        'padding-bottom': showBottomNavbar ? '70px' : '0px',
      }"
    >
      <v-btn
        v-if="checkFloatPanel"
        fab
        dark
        :color="site.color"
        class="mr-6"
        @click="dialogFloatPanel = true"
      >
        <v-icon>mdi-menu</v-icon>
      </v-btn>
    </div>

    <FloatPanel
      :dialog="dialogFloatPanel"
      @onClose="dialogFloatPanel = false"
    />

    <!--dialog detail reward -->
    <dialogDetailReward
      :dialogDetail="dialogDetail"
      :item="item"
      :site="site"
      :keyComponent="keyComponent"
      @addFavorite="addFavorite"
      @deleteFavorite="deleteFavorite"
      @redeemRewardFinal="redeemRewardFinal"
      @close="dialogDetail = false"
    />

    <!-- Fern: Confirm Redeem Final dialog -->
    <DialogConfirmRedeemFinal
      :dialogConfirmRedeemFinalVisible="dialogConfirmRedeemFinalVisible"
      :site="site"
      :item="item"
      :quantity="quantity"
      @close="closeConfirmDialog"
    />
  </v-container>
</template>

<script>
import InfiniteLoading from "vue-infinite-loading";
import Axios from "@/config/customer-service";
import { mapState } from "vuex";
import moment from "moment";
import { adjustHslBrightness } from "@/config/general-function";
import dialogDetailReward from "@/components/reward/dialogDetail.vue";
import DialogConfirmRedeemFinal from "@/components/reward/dialogConfirmRedeemFinal.vue";
import FloatPanel from "@/components/floatPanel.vue";
import {
  checkImage,
  getFontColorBasedOnBg,
  getLandingPage,
} from "../../../config/general-function";
import PointSymbol from "../../../components/point/point-symbol.vue";

export default {
  inject: ["isAppLoading"],
  components: {
    InfiniteLoading,
    dialogDetailReward,
    DialogConfirmRedeemFinal,
    FloatPanel,
    PointSymbol,
  },
  data: () => ({
    dialogFloatPanel: false,
    data: [],
    group: null,
    model: null,
    dataItems: [],
    dialogDeleteFavorite: false,
    dialogDetail: false,
    dialogAddFavorite: false,
    dialogConfirmRedeemFinalVisible: false,
    item: "",
    next_page_url: "",
    infiniteId: +new Date(),
    keyComponent: 0,
    quantity: null,
    category: "all",
    categoryList: [],
    partnerList: [],
    customHeaderPage: "reward",
    customHeader: {
      isUseCustomHeader: false,
      isUseTitle: true,
      image: null,
      titleColor: "#ffffff",
    },
    reward_id: null,
    previousRouteName: null,
  }),
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // vm คือตัวแทนของ this
      const currentRouteName = to.name;
      if (from?.fullPath && from?.fullPath !== "/") {
        sessionStorage.setItem(
          currentRouteName + "_prev_route_name",
          from.name
        );
        vm.previousRouteName = from.name;
      } else {
        vm.previousRouteName = sessionStorage.getItem(
          currentRouteName + "_prev_route_name"
        );
      }
    });
  },
  async created() {
    this.isAppLoading(true);
    this.reward_id = this.$route.query.reward_id || null;
    this.getCategory();
    this.getPartnerList();
    // ========== ========== ========== ==========
    if (this.site?.page_header_cover[this.customHeaderPage]) {
      this.customHeader.isUseCustomHeader =
        this.site?.page_header_cover[
          this.customHeaderPage
        ].is_use_custom_header;
      this.customHeader.isUseTitle =
        this.site?.page_header_cover[this.customHeaderPage].is_use_title;
      const page_header_cover_image =
        this.site?.page_header_cover[this.customHeaderPage].image;
      const _check_image = await checkImage(page_header_cover_image);
      this.customHeader.image = _check_image ? page_header_cover_image : null;
      this.customHeader.titleColor = "#ffffff";
      if (this.customHeader.isUseCustomHeader) {
        this.customHeader.titleColor =
          this.site?.page_header_cover[this.customHeaderPage].title_color ||
          "#ffffff";
      }
    }
    // ========== ========== ========== ==========
    if (this.reward_id) {
      this.getRewardByPass(this.reward_id);
    }
  },
  methods: {
    redirectTo() {
      if (this.previousRouteName) {
        this.$router.go(-1);
      } else {
        let listRouteName = [];
        if (
          Array.isArray(this.site?.bottom_nav_bar?.menu) &&
          this.site?.bottom_nav_bar?.menu?.length > 0
        ) {
          const listRouteAllow = this.site?.bottom_nav_bar.menu.map(
            (x) => x.route_allow
          );
          for (let item of listRouteAllow) {
            listRouteName = [...listRouteName, ...item];
          }
        }
        if (listRouteName.length > 0) {
          this.$router.push({ name: listRouteName[0] });
        } else {
          const landing_page = getLandingPage();
          const targetRoute = this.$router.resolve({
            name: landing_page,
          });
          window.location.href = targetRoute.href;
        }
      }
    },
    setBackgoundBox() {
      const _color = this.site.color || "#00000";
      const darken = adjustHslBrightness(_color, -20);
      let _style = `linear-gradient(120deg, ${_color}, ${darken})`;
      if (this.customHeader.isUseCustomHeader && this.customHeader.image) {
        _style = `url("${this.customHeader.image}") center / cover no-repeat`;
      }
      return _style;
    },
    checkTitleShadow() {
      let shadow = "rgb(224 224 224) 2px 1px 1px";
      const color = getFontColorBasedOnBg(this.customHeader.titleColor, "bw");
      if (color == "#000000") {
        shadow = "rgb(66, 68, 90) 2px 1px 1px";
      }
      return shadow;
    },
    setBorderRadiusBox() {
      let _style = `0px 0px 25px 25px`;
      if (this.customHeader.isUseCustomHeader && this.customHeader.image) {
        _style = `0px !important`;
      }
      return _style;
    },
    removeQueryRewardID() {
      const url = new URL(window.location.href);
      url.searchParams.delete("reward_id");
      window.history.replaceState(
        {},
        document.title,
        url.pathname + url.search
      );
    },
    // ========== ========== Partner ========== ==========
    getPartnerList() {
      this.partnerList = [];
      Axios.get("partner/getPartnerList", {
        params: {
          type: "reward",
        },
      })
        .then(({ data }) => {
          if (data.status == "success") {
            if (Array.isArray(data.data)) {
              this.partnerList = [...data.data];
            }
          }
        })
        .catch((err) => {
          console.log("getPartnerList", err);
        });
    },
    handleOpenPartner(param) {
      this.$router.push({
        name: "reward-partner",
        params: { partner_code: param.partner_code },
      });
    },

    // ========== ========== ========== ==========
    infiniteHandler($state) {
      Axios.get("reward/listReward", {
        params: {
          category: this.category,
          cursor: this.next_page_url,
        },
      })
        .then(({ data }) => {
          setTimeout(() => {
            this.isAppLoading(false);
          }, 1000);
          if (data.data.data.length) {
            let has_more = data.data.has_more;
            this.dataItems = this.dataItems.concat(data.data.data);
            if (!has_more) {
              $state.complete();
              return;
            }
            this.next_page_url = data.data.next_page_url.split("=")[1];
            $state.loaded();
          } else {
            $state.complete();
          }
        })
        .catch((err) => {
          console.log("infiniteHandler[err]", err);
        });
    },
    initialize(cate) {
      this.isAppLoading(true);
      this.dataItems = [];
      this.next_page_url = "";
      this.infiniteId += 1;
      this.category = cate ? cate.value : "all";
    },
    getCategory() {
      Axios.get("reward/listRewardCategory").then(({ data }) => {
        if (data.status == "success") {
          let cate = data.data;
          cate.map((item) => {
            this.categoryList.push({
              icon: item.icon,
              label: item.label,
              value: item.category,
            });
          });
          this.categoryList.unshift({
            icon: "order-bool-ascending",
            label: this.$t("categoryAll"),
            value: "all",
          });
        }
      });
    },
    getRewardByPass(reward_id) {
      Axios.get(`reward/getRewardByPass`, {
        params: {
          reward_id: reward_id,
        },
      })
        .then((res) => {
          if (res.data.status == "success") {
            const { data } = res.data;
            if (data?.limit_reached) {
              this.$swal.fire({
                icon: "error",
                title: this.$t("rewardLimitReached"),
                showConfirmButton: false,
                timer: 3000,
              });
              return;
            }
            this.confirmRedeem(data);
          } else {
            this.$swal.fire({
              icon: "error",
              title: JSON.stringify(res.data.message),
              showConfirmButton: false,
              timer: 3000,
            });
          }
        })
        .catch((err) => {
          this.$swal.fire({
            icon: "error",
            title: JSON.stringify(err.response.data.message),
            showConfirmButton: false,
            timer: 3000,
          });
        })
        .finally(() => {
          this.removeQueryRewardID();
        });
    },

    // ========== ========== Favorite ========== ==========
    addFavorite() {
      Axios.post(`reward/addFevoriteItem`, {
        reward_id: this.item.id,
      })
        .then((res) => {
          if (res.data.status == "success") {
            this.item.is_fevorite = !this.item.is_fevorite;
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 1500,
            });
            Toast.fire({
              icon: "success",
              title: res.data.message,
            });
          }
        })
        .catch((err) => {
          this.$swal.fire({
            icon: "error",
            title: JSON.stringify(err.response.data.message),
            showConfirmButton: false,
            timer: 3000,
          });
        });
    },
    deleteFavorite() {
      Axios.delete(`reward/deleteFavoriteItem`, {
        data: { reward_id: this.item.id },
      })
        .then((res) => {
          if (res.data.status == "success") {
            this.item.is_fevorite = !this.item.is_fevorite;
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 1500,
            });
            Toast.fire({
              icon: "success",
              title: res.data.message,
            });
          }
        })
        .catch((err) => {
          this.$swal.fire({
            icon: "error",
            title: JSON.stringify(err.response.data.message),
            showConfirmButton: false,
            timer: 3000,
          });
        });
    },

    // ========== ========== Map ========== ==========
    checkExpire(date, limit_reached) {
      if (limit_reached) return limit_reached;
      return moment().isAfter(date, "day");
    },

    // ========== ========== ========== ==========
    confirmRedeem(item) {
      if (item.limit_reached) return;
      this.item = item;
      Axios.get(`reward/getReward`, {
        params: {
          reward_id: item.id,
        },
      })
        .then((res) => {
          if (res.data.status == "success") {
            const { data } = res.data;
            this.item = { ...this.item, ...data };
            this.dialogDetail = true;
          }
        })
        .catch((err) => {
          this.$swal.fire({
            icon: "error",
            title: JSON.stringify(err.response.data.message),
            showConfirmButton: false,
            timer: 3000,
          });
        });
    },
    closeConfirmDialog(all) {
      if (all) {
        this.dialogDetail = false;
      } else {
        this.dialogDetail = true;
      }
      this.dialogConfirmRedeemFinalVisible = false;
    },
    redeemRewardFinal(quantity) {
      this.quantity = quantity;
      this.dialogDetail = false;
      this.dialogConfirmRedeemFinalVisible = true;
    },
  },
  computed: {
    ...mapState("defaultSystem", ["site"]),
    getCustomer() {
      return { ...this.$store.getters["defaultSystem/getCustomer"] };
    },
    inBottomNavbar() {
      let check = false;
      // ========== ========== ========== ==========
      const curRouteName = this.$router.currentRoute.name;
      let listRouteName = [];
      if (
        Array.isArray(this.site?.bottom_nav_bar?.menu) &&
        this.site?.bottom_nav_bar?.menu?.length > 0
      ) {
        const listRouteAllow = this.site?.bottom_nav_bar.menu.map(
          (x) => x.route_allow
        );
        for (let item of listRouteAllow) {
          listRouteName = [...listRouteName, ...item];
        }
      }
      if (listRouteName.length > 0 && listRouteName.includes(curRouteName)) {
        check = true;
      }
      return check;
    },
    showBottomNavbar() {
      let check = false;
      // ========== ========== ========== ==========
      let checkInRoute = true;
      const curRouteName = this.$route.name;
      let listRouteName = [];
      if (
        Array.isArray(this.site?.bottom_nav_bar?.menu) &&
        this.site?.bottom_nav_bar?.menu?.length > 0
      ) {
        const listRouteAllow = this.site?.bottom_nav_bar.menu.map(
          (x) => x.route_allow
        );
        for (let item of listRouteAllow) {
          listRouteName = [...listRouteName, ...item];
        }
      }
      if (listRouteName.length > 0 && !listRouteName.includes(curRouteName)) {
        checkInRoute = false;
      }
      // ========== ========== ========== ==========
      if (this.site.is_use_bottom_nav && checkInRoute) {
        check = true;
      }
      return check;
    },
    checkFloatPanel() {
      let check = false;
      if (this.site.is_use_float_panel) {
        const float_panel_main_menu = this.site.float_panel_main?.menu || [];
        const float_panel_extend_menu =
          this.site.float_panel_extend?.menu || [];
        const model_main_all_open = float_panel_main_menu.find((x) => x.show);
        const model_extend_all_open = float_panel_extend_menu.find(
          (x) => x.show
        );
        if (model_main_all_open || model_extend_all_open) {
          check = true;
        }
      }
      return check;
    },
  },
  filters: {
    commaPoint(value) {
      if (value == 0) {
        return "0";
      } else if (value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
  },
};
</script>

<style scoped>
.fab-container {
  position: fixed;
  bottom: 16px;
  right: 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  z-index: 1;
}

.v-btn__content {
  display: flex;
  flex-direction: column;
}

.v-btn-toggle:not(.v-btn-toggle--dense) .v-btn.v-btn.v-size--default {
  height: 80px;
  min-width: 95px;
  border-radius: 10px;
}

.bar-header {
  height: 150px;
  font-size: 14px;
}

.bar-image {
  height: 210px;
  font-size: 14px;
}

.v-btn-toggle--group > .v-btn.v-btn {
  background-color: white !important;
  border-color: transparent;
}

.v-btn--absolute.v-btn--top,
.v-btn--fixed.v-btn--top {
  top: 3px;
}

.v-btn--absolute.v-btn--right,
.v-btn--fixed.v-btn--right {
  right: 5px;
}

.v-slide-group__content {
  justify-content: start !important;
}

.bottomleft {
  position: absolute;
  bottom: 8px;
  left: 16px;
  font-size: 18px;
}

.btn-close {
  position: absolute;
  margin-bottom: -100px;
  z-index: 888;
  right: 0;
}

.empty {
  opacity: 1;
}

.card-container {
  position: relative;
  aspect-ratio: 1 / 1.5;
}

.disabled-card {
  /* background-color: #00000033; */
}

.cover-card-disable {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 1;
  /* background-color: #00000099; */
}

.cover-card-disable .label {
  font-size: 16px;
  font-weight: 500;
  /* color: #FFFFFF; */
  color: #000000;
  border-radius: 16px;
  background-color: #ffffff;
  padding: 0px 8px;
  margin: 0px 0px 72px 0px;
}

.custom-slide-btn {
  background-color: #ffffff !important;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.15) !important;
  transition: all 0.2s ease-in-out;
}

.custom-slide-btn:hover {
  background-color: #f5f5f5 !important;
  transform: scale(1.08);
}

.custom-slide-btn .v-icon {
  color: #333333 !important;
}
</style>
